import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	titleWhiteboard: {
		id: 'prompt-competitor-link.prompt-whiteboard.title-whiteboard',
		defaultMessage: 'Try Confluence whiteboards',
		description: 'Popup title to bring awareness to the whiteboards feature',
	},
	descriptionDefaultWhiteboard: {
		id: 'prompt-competitor-link.prompt-whiteboard.description-default-whiteboard',
		defaultMessage: 'To brainstorm and ideate without switching tools, try Confluence whiteboards.',
		description:
			'Context which explains that whiteboards are a better alternative to the detected competitor as it keeps all work within Confluence',
	},
	descriptionImportWhiteboard: {
		id: 'prompt-competitor-link.prompt-whiteboard.description-import-whiteboard',
		defaultMessage:
			'Reduce context switching by importing your work to a Confluence whiteboard instead.',
		description:
			'Context which explains that whiteboards are a better alternative to the detected competitor as it keeps all work within Confluence and brings awareness of the Importer feature',
	},
	createButtonDefaultWhiteboard: {
		id: 'prompt-competitor-link.prompt-whiteboard.create-button-default-whiteboard',
		defaultMessage: 'Create a whiteboard',
		description: 'Button to create and redirect the user to a new whiteboard',
	},
	createButtonImportWhiteboard: {
		id: 'prompt-competitor-link.prompt-whiteboard.create-button-import-whiteboard',
		defaultMessage: 'Import from {competitorName}',
		description:
			'Button to create and redirect the user to a new whiteboard as well as open the Importer',
	},
	dismissButton: {
		id: 'prompt-competitor-link.prompt-whiteboard.dismiss-button',
		defaultMessage: 'Do not show for whiteboards again',
		description:
			'Button to close the popup and stop displaying the prompt icon and popup everywhere on the current page and not show it again for whiteboards variant of the prompt',
	},
	whiteboardIconAltText: {
		id: 'prompt-competitor-link.prompt-whiteboard.icon-alt-text',
		defaultMessage: 'Confluence Whiteboard',
		description: 'Alternative text for the Confluence Whiteboard icon',
	},
	successFlagTitle: {
		id: 'prompt-competitor-link.prompt-whiteboard.success-flag-title',
		defaultMessage: 'Whiteboard added to content tree',
		description: 'Title for success flag when whiteboard is created.',
	},
	successFlagDescription: {
		id: 'prompt-competitor-link.prompt-whiteboard.success-flag-description',
		defaultMessage:
			'The whiteboard has been created in the tree. Go to the whiteboard to move its location or change its permissions.',
		description: 'Description for success flag when whiteboard is created.',
	},
	successFlagAction: {
		id: 'prompt-competitor-link.prompt-whiteboard.success-flag-action',
		defaultMessage: 'Go to whiteboard',
		description: 'Action for success flag when whiteboard is created.',
	},
	createdFlagTitle: {
		id: 'prompt-competitor-link.prompt-whiteboard.created-flag-title',
		defaultMessage: 'Whiteboard successfully created',
		description: 'Title for flag when whiteboard is created and user navigates to it.',
	},
	createdFlagDescription: {
		id: 'prompt-competitor-link.prompt-whiteboard.created-flag-description',
		defaultMessage:
			'This whiteboard was created as a child item of the content you were working on.',
		description: 'Description for flag when whiteboard is created and user navigates to it.',
	},
	createdFlagAction: {
		id: 'prompt-competitor-link.prompt-whiteboard.created-flag-action',
		defaultMessage: 'Go back to previous content',
		description: 'Action for flag when whiteboard is created and user navigates to it.',
	},
	defaultErrorFlagTitle: {
		id: 'prompt-competitor-link.prompt-whiteboard.default-error-flag-title',
		defaultMessage: 'We’re unable to create right now',
		description: 'Title for error flag when content fails to create.',
	},
	defaultErrorFlagDescription: {
		id: 'prompt-competitor-link.prompt-whiteboard.default-error-flag-description',
		defaultMessage:
			'Refresh or wait a few minutes and try again. If this keeps happening, contact support.',
		description: 'Description for error flag when content fails to create.',
	},
});
